module.exports = __webpack_public_path__ + "img/微信图片_20210903171831.cdd9c769.png";